"use strict";
var mat4 = require('gl-matrix/src/gl-matrix/mat4');
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var quat = require('gl-matrix/src/gl-matrix/quat');
var scratch0 = mat4.create();
// Rotate Y by Math.PI
var qy = quat.fromValues(0, 1, 0, 0);
var v1 = vec3.create();
var q1 = quat.create();
var m1 = mat4.create();
var BasicCamera = (function () {
    function BasicCamera(parent) {
        this.parent = parent;
        this.position = vec3.fromValues(0, 0.7, 0);
        this.rotationX = 0;
        this.modelMatrix = mat4.create();
        this.modelMatrixNeedsUpdate = true;
    }
    BasicCamera.prototype.updateModelMatrix = function () {
        var updated = this.parent.updateModelMatrixRecursively();
        if (updated || this.modelMatrixNeedsUpdate) {
            vec3.set(v1, -this.position[0], this.position[1], -this.position[2]);
            quat.rotateX(q1, qy, -this.rotationX);
            mat4.fromRotationTranslation(this.modelMatrix, q1, v1);
            vec3.inverse(v1, this.parent.scale);
            mat4.scale(m1, this.parent.modelMatrix, v1);
            mat4.multiply(this.modelMatrix, m1, this.modelMatrix);
            this.modelMatrixNeedsUpdate = false;
        }
    };
    BasicCamera.prototype.view = function (output) {
        this.updateModelMatrix();
        mat4.invert(output, this.modelMatrix);
        return output;
    };
    BasicCamera.prototype.getCameraVector = function (v) {
        // TODO: Need to normalize?
        v[0] = this.modelMatrix[8];
        v[1] = this.modelMatrix[9];
        v[2] = this.modelMatrix[10];
        return v;
    };
    BasicCamera.prototype.setRotationX = function (angle) {
        this.rotationX = angle;
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    // TODO: add to basic-camera, as in orbit-camera (https://github.com/hughsk/basic-camera/issues/5)
    BasicCamera.prototype.lookAt = function (eye, center, up) {
        console.log(eye, center, up);
    };
    ;
    return BasicCamera;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BasicCamera;
//# sourceMappingURL=BasicCamera.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/cameras/FpsCamera/BasicCamera.js
 ** module id = 921
 ** module chunks = 0
 **/